import r from "./index.ce.vue2.js";
import o from "./index.ce.vue3.js";
import t from "../../_virtual/_plugin-vue_export-helper.js";
const e = /* @__PURE__ */ t(r, [["styles", [o]]]);
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/mall-sp-approval-trigger/index.ce.vue.js
// module id = 831
// module chunks = 41